import _ from 'lodash'
import ChartDesigner from 'scoreboard/charts/model/chart-designer'

/**
 * Returns true if the given item is "pie-like" (includes donut). Can check
 * a plain String or a ChartDesigner model
 */
function pieLike (something) {
	if (typeof something === 'string') {
		return pieLikePlotType(something)
	}

	if (something instanceof ChartDesigner) {
		return !!something.features
			.filter(f => f.get('type') === 'serie')
			.map(s => s.get('plotType'))
			.find(it => it === 'pie' || it === 'donut')
	}
}

function pieLikeSeries (series) {
	return pieLikePlotType(series.properties.get('plotType'))
}

function pieLikePlotType (plotType) {
	return _.includes(['pie', 'donut'], plotType)
}

export default pieLike

pieLike.__filename__ = 'charts/pie-like.js'
